import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { AuthService } from './../../../../../services/auth.service';
import { SpaceService } from './../../../../../services/space.service';
import { MemberService } from './../../../../../rest/api/member.service';
import { HelperService } from './../../../../../services/helper.service';
import { ImageHelper } from './../../../../../validator/image-helper';

@Component({
  selector: 'app-create-info-hotspots',
  templateUrl: './create-info-hotspots.component.html',
  styleUrls: ['./create-info-hotspots.component.scss']
})
export class CreateInfoHotspotsComponent implements OnInit, OnChanges {
  @Input() spaceData;
  @Input() mediaData;
  @Input() selectedMedia;
  @Input() selectedMesh;
  @Input() editHotspots;
  @Output() createHotspotEmit = new EventEmitter();
  @Output() deleteHotspotEmit = new EventEmitter();
  @Output() updateHotspotEmit = new EventEmitter();
  @Output() closeHotSpotBoxEmit = new EventEmitter();
  @Output() deleteInfoMediaHotspotEmit = new EventEmitter();
  @ViewChild('imageFile') imageFile: ElementRef;

  urlPattern = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';

  createHotspotForm: FormGroup;
  accessToken: any;
  isSubmitting = false;
  isSubmitted = false;
  imageLoader = false;

  errors = [];
  successMsg: string;
  errorMsg: string;

  uploadErr: string;
  selectedFile: any;
  mediaFile = '';
  fileText = 'Browse file';
  mediaFileData: any;

  constructor(
    public fb: FormBuilder,
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
    public spaceService: SpaceService
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.createHotspotsFormInit();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.editHotspots && changes.editHotspots.currentValue) {
      this.isSubmitted = false;
      this.isSubmitting = false;
      this.resetFormValues(changes.editHotspots.currentValue);
    } else {
      this.isSubmitted = false;
      this.isSubmitting = false;
      this.resetFormValues(undefined);
    }
  }

  createHotspotsFormInit() {
    this.createHotspotForm = this.fb.group({
      title: ['', [Validators.required, Validators.maxLength(40)]],
      description: [''],
      external_url: ['', [Validators.pattern(this.urlPattern)]],
      embed_url: ['', []],
      media: [''],
    });
  }

  onFileChange(event) {
    this.imageLoader = true;
    this.uploadErr = undefined;
    if (event.target.files.length === 0) { return; }
    this.selectedFile = event.target.files[0] as File;

    const name = this.selectedFile && this.selectedFile.name;
    if (name) {
      this.fileText = name;
    }

    const fileExtension = name.split('.').pop();

    if (ImageHelper.isMediaSizeExceeded(this.selectedFile.size)) {
      event.target.value = null;
      this.uploadErr = 'Please upload file less than 20 MB.';
      return;
    }

    if (ImageHelper.isMediaTypeValid(fileExtension)) {
      event.target.value = null;
      this.uploadErr = 'Please upload valid file type (i.e jpeg, jpg, png).';
      return;
    }
    this.mediaFileData = undefined;

    // const formData = {
    //   space_media_id: this.selectedMedia.uuid,
    //   file: this.selectedFile
    // };

    this.spaceService.uploadHotSpotInfoMedia(this.selectedFile, this.selectedMedia.uuid, this.accessToken).subscribe((response: any) => {
      this.imageLoader = false;
      if (response && response.data && response.data.file) {
        this.createHotspotForm.controls.media.setValue(response.data.file);
      }
      if (response && response.data && response.data.url) {
        this.mediaFileData = response.data.url;
      }
    }, err => {
      this.imageLoader = false;
      this.uploadErr = err.error && err.error.error ? err.error.error : 'There was error while uploading your file.';
    });

  }

  submit(value) {
    if (!this.createHotspotForm.valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    data.media_id = this.selectedMedia.uuid;
    data.coordinates = this.selectedMesh.position;
    if (this.editHotspots) {
      this.updateHotspots(data);
    } else {
      this.createHotspots(data);
    }
  }

  resetErrors() {
    this.errorMsg = undefined;
    this.errors = [];
  }

  createHotspots(data) {
    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.createInfoHotspot({
      Authorization: this.accessToken,
      body: formData
    }).subscribe((response: any) => {
      this.resetForm();
      this.successMsg = 'New info hotspot was successfully created.';
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      setTimeout(() => {
        this.resetErrorValues();
        const responseData = response && response.data ? response.data : undefined;
        this.createHotspotEmit.emit(responseData);
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  updateHotspots(data) {
    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.updateInfoHotspot({
      Authorization: this.accessToken,
      id: this.editHotspots.uuid,
      body: formData
    }).subscribe((response: any) => {
      this.resetForm();
      this.successMsg = 'Info hotspot was successfuly updated.';
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      setTimeout(() => {
        this.resetErrorValues();
        const responseData = response && response.data ? response.data : undefined;
        this.updateHotspotEmit.emit(responseData);
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.resetFormValues(undefined);
  }

  resetFormValues(data) {
    if (!data) {
      this.createHotspotForm.reset({
        title: '',
        description: '',
        external_url: '',
        embed_url: ''
      });
    } else {
      this.mediaFileData = data.media && data.media !== '' ? data.media : undefined;
      this.createHotspotForm.reset({
        title: data.title,
        description: data.description,
        external_url: data.external_url,
        embed_url: data.embed_url ? 'https://www.youtube.com/watch?v=' + data.embed_url : ''
      });
    }
  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'There was error while creating hotspot.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

  resetErrorValues() {
    this.isSubmitted = false;
    this.errorMsg = undefined;
    this.successMsg = undefined;
    this.isSubmitting = false;
    this.isSubmitted = false;
    this.mediaFileData = undefined;
    if (this.imageFile) {
      this.imageFile.nativeElement.value = '';
    }
    this.fileText = 'Browse file';
  }

  deleteHotspot() {
    this.deleteHotspotEmit.emit('info');
  }

  modalCloseEmit(hotspot) {
    this.mediaFileData = undefined;
    if (this.imageFile) {
      this.imageFile.nativeElement.value = '';
    }
    if ($('#deleteModal')) {
      $('#deleteModal').modal('hide');
    }
    if (hotspot) {
      this.deleteHotspotEmit.emit(hotspot);
    }
  }

  closeHotSpotBox() {
    this.closeHotSpotBoxEmit.emit('info');
  }

  deleteMedia() {
    if (this.editHotspots) {
      this.memberService.deleteInfoMedia({
        Authorization: this.accessToken,
        id: this.editHotspots.uuid
      }).subscribe((response: any) => {
        this.mediaFileData = undefined;
        if (this.imageFile) {
          this.imageFile.nativeElement.value = '';
        }
        this.fileText = 'Browse file';
        this.createHotspotForm.controls.media.setValue('');
        this.editHotspots.media = '';
        this.editHotspots.media_type = '';
        this.deleteInfoMediaHotspotEmit.emit(this.editHotspots);
      }, err => {
        this.handleErrors(err);
      });
      // deleteInfoMedia
    } else {
      this.mediaFileData = undefined;
      if (this.imageFile) {
        this.imageFile.nativeElement.value = '';
      }
      this.fileText = 'Browse file';
      this.createHotspotForm.controls.media.setValue('');

    }

  }

}
